import './Unit.css';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

export default function Unit(props) {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: props.id,
  });
  const style = {
    // Outputs `translate3d(x, y, 0)`
    transform: CSS.Translate.toString(transform),
    touchAction: 'none'
  };
  const l = 25;
  const r = 20
  const color = '#d6c527';

  return (
    <div className='unit' ref={setNodeRef} style={style} {...listeners} {...attributes} onClick={props.rotateClockwise}>
      <p className='prevent-select'>{props.id}</p>
      {props.rotation !== undefined &&
          <svg width='50px' height='50px' style={{ position: 'absolute' }}>
          <circle cx={l} cy={l} r={r} fill='none' stroke={color} strokeWidth='2px' />
          <polyline points={`${l + Math.sqrt(3) / 2 * r},${l - 1 / 2 * r} ${2 * l},${l} ${l + Math.sqrt(3) / 2 * r}, ${l + 1 / 2 * r}`} transform={`rotate(${props.rotation === undefined ? 0 : props.rotation}, ${l} ${l})`} fill="none" stroke={color} strokeWidth='2px' />
        </svg>
      }
    </div>
  );
}